import { useQuery } from "@tanstack/react-query";

interface MarketData {
  symbol: string;
  name: string;
  price: number;
  change24h: number;
  volume24h: number;
  marketCap: number;
}

const mockMarketData: MarketData[] = [
  {
    symbol: "BTC",
    name: "Bitcoin",
    price: 96750.45,
    change24h: 2.34,
    volume24h: 28500000000,
    marketCap: 1905000000000,
  },
  {
    symbol: "ETH",
    name: "Ethereum",
    price: 3456.78,
    change24h: -1.23,
    volume24h: 15200000000,
    marketCap: 415000000000,
  },
  {
    symbol: "BNB",
    name: "BNB",
    price: 712.45,
    change24h: 3.45,
    volume24h: 1800000000,
    marketCap: 105000000000,
  },
  {
    symbol: "SOL",
    name: "Solana",
    price: 198.56,
    change24h: 5.67,
    volume24h: 3200000000,
    marketCap: 89000000000,
  },
  {
    symbol: "XRP",
    name: "XRP",
    price: 2.34,
    change24h: -2.45,
    volume24h: 2800000000,
    marketCap: 134000000000,
  },
];

export const useMarketData = () => {
  return useQuery({
    queryKey: ["marketData"],
    queryFn: async () => {
      // Simulate API delay
      await new Promise((resolve) => setTimeout(resolve, 500));
      return mockMarketData;
    },
    staleTime: 30000,
  });
};
